import { IS_WEB } from 'constants/platform'
import React from 'react'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { ChatCoachItem } from 'widgets/CoachItem/ChatCoachItem'
import { FlatList } from 'widgets/FlatList'
import { NoCoaches } from 'widgets/NoCoaches'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { useChatRoomTrainers } from 'hooks/useChatRoomTrainers'
import { useCurrentUser } from 'hooks/useCurrentUser'

import { useFocusMode } from 'contexts/FocusModeContext'

import { UserType } from 'types/user'

type MyCoachesProps = {
  isSquare?: boolean
  noCoachesHeaderText?: string
  noCoachesBodyText?: string
  withLeaderboardPosition?: boolean
  isUpspace?: boolean
  withUpspacesTitle?: boolean
}

export const MyCoaches = ({
  noCoachesHeaderText = '',
  noCoachesBodyText = '',
  isSquare = false,
  withLeaderboardPosition = false,
  isUpspace = false,
  withUpspacesTitle = false,
}: MyCoachesProps) => {
  const focusMode = useFocusMode()
  const { data: currentUser } = useCurrentUser()
  const { data: chatRoomTrainers, isLoading: isLoadingChatRoomTrainers } = useChatRoomTrainers()

  const filteredTrainer = chatRoomTrainers?.find(
    (trainer) => trainer.id === focusMode.group?.trainer.id,
  )
    ? chatRoomTrainers?.filter((trainer) => trainer.id === focusMode.group?.trainer.id)[0]
    : []

  return (
    <Box align='center' justifyContent='center'>
      {isLoadingChatRoomTrainers && (
        <Text align='center' fontSize='sm' color='greyDark'>
          Loading...
        </Text>
      )}
      {chatRoomTrainers && !isLoadingChatRoomTrainers && (
        <Box flexDirection='column' width='100%'>
          {chatRoomTrainers.length > 0 ? (
            <>
              <Box testID='MyCoachesTitle'>
                {withUpspacesTitle && (
                  <Title bold>{focusMode.group ? 'Group chat' : 'Groups'}</Title>
                )}
              </Box>

              <Box flexDirection={IS_WEB ? 'column' : 'row'} width='100%'>
                <FlatList<UserType>
                  horizontal
                  data={focusMode.group ? [filteredTrainer] : chatRoomTrainers}
                  loading={isLoadingChatRoomTrainers}
                  renderItem={({ item: user }) => {
                    if (isUpspace) {
                      return (
                        <ChatCoachItem
                          user={user}
                          isSquare={isSquare}
                          withLeaderboardPosition={withLeaderboardPosition}
                          isUpspace
                        />
                      )
                    }
                    return (
                      <CoachItem
                        displayedForUser={currentUser}
                        user={user}
                        isSquare={isSquare}
                        withLeaderboardPosition={withLeaderboardPosition}
                      />
                    )
                  }}
                  keyExtractor={(user) => `${user?.id}-coach`}
                />
              </Box>
            </>
          ) : (
            <NoCoaches headerText={noCoachesHeaderText} bodyText={noCoachesBodyText} />
          )}
        </Box>
      )}
    </Box>
  )
}
